<template>
  <div class="app-download-buttons-fi">
    <template v-for="button in buttons">
      <div
        v-if="!isEditMode && button.img && button.link"
        :key="button.id"
        class="app-download-buttons-fi__button"
      >
        <a
          :href="button.link.url ? button.link.url : button.link.href"
          :target="button.link.target"
          :title="button.link.title"
          :rel="button.link.url && button.link.target === '_blank' ? 'noopener noreferrer' : null"
        >
          <img
            class="app-download-buttons-fi__image"
            :src="button.img.src"
            :alt="button.img.alt"
          />
        </a>
      </div>
      <div
        v-if="isEditMode"
        :key="button.id"
      >
        <!-- eslint-disable vue/no-v-html -->
        <div
          class="fi-mb-9"
          v-html="button.imgEdit"
        />
        <div v-html="button.linkEdit" />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'AppDownloadButtonsFi',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    buttons() {
      return [
        {
          id: 'button-left',
          img: this.buttonLeft,
          imgEdit: this.fields?.buttonLeft?.editable,
          link: this.buttonLeftLink,
          linkEdit: this.fields?.buttonLeftLink?.editable,
        },
        {
          id: 'button-right',
          img: this.buttonRight,
          imgEdit: this.fields?.buttonRight?.editable,
          link: this.buttonRightLink,
          linkEdit: this.fields?.buttonRightLink?.editable,
        },
      ];
    },
    buttonLeft() {
      if (this.fields.buttonLeft?.value?.src) {
        return this.fields.buttonLeft.value;
      }

      return false;
    },
    buttonLeftLink() {
      if (
        this.fields.buttonLeftLink?.value &&
        (this.fields.buttonLeftLink.value.url || this.fields.buttonLeftLink.value.href)
      ) {
        return this.fields.buttonLeftLink.value;
      }

      return false;
    },
    buttonRight() {
      if (this.fields.buttonRight?.value?.src) {
        return this.fields.buttonRight.value;
      }

      return false;
    },
    buttonRightLink() {
      if (
        this.fields.buttonRightLink?.value &&
        (this.fields.buttonRightLink.value.url || this.fields.buttonRightLink.value.href)
      ) {
        return this.fields.buttonRightLink.value;
      }

      return false;
    },
  },
};
</script>

<style scoped lang="scss">
@import './app-download-buttons-fi';
</style>
